import React from 'react'
import styled from 'styled-components'
import FullscreenColorTeaser from 'uiComponents/atoms/FullscreenColorTeaser/FullscreenColorTeaser'
import ScrollDownIcon from 'uiComponents/atoms/ScrollDownIcon/ScrollDownIcon'

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1 1 100%;
  align-items: center;
  justify-content: center;
  height: 100%;
`

interface IProps {
  color: string
  targetScrollElementRef: React.RefObject<HTMLElement | null>
  className?: string
}

const ColorTeaser: React.FC<React.PropsWithChildren<IProps>> = props => {
  const { color, children, targetScrollElementRef, className } = props

  return (
    <FullscreenColorTeaser color={color} className={className}>
      <Container>{children}</Container>
      <ScrollDownIcon targetScrollElementRef={targetScrollElementRef} />
    </FullscreenColorTeaser>
  )
}

export default ColorTeaser
